"use client";
import * as React from "react";
import {Box, Button, Typography} from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import {useSelector} from "react-redux";
import {RootState} from "@/redux/store";
import {PATHS} from "@/utils/paths";


const partsData = [
    {
        title: "لیست کامل قطعات ایساکو",
        baseName: "LogoISACO",
        companyName: "ایساکو",
    },
    {
        title: "لیست کامل قطعات ايران کاربراتور",
        baseName: "LogoIRCA",
        companyName: "ايران کاربراتور",
    },
    {
        title: "لیست کامل قطعات بابا‌‌پارت",
        baseName: "LogoBABA",
        companyName: "ساز يدک",
    },
];


export default function PartsList() {
    const [hoveredIndex, setHoveredIndex] = React.useState<number | null>(null);
    const data = useSelector((state: RootState) => state.layout.productGroups);

    const companyOptions = Array.isArray(data)
        ? data.filter((pg) => pg.pLevel === 0).map((group) => ({
            label: group.name,
            value: group.id,
            image: group.picture,
        }))
        : [];

    const handleTouchStart = (index: number) => {
        setHoveredIndex(index);
    };

    const handleTouchEnd = () => {
        setHoveredIndex(null);
    };


    const findCompanyId = (brandNameToFind: string): string | undefined => {
        const foundOption = companyOptions.find(option =>
            option.label.toLowerCase().includes(brandNameToFind.toLowerCase())
        );
        return foundOption ? foundOption.value : undefined;
    };

    const getPartLink = (part: typeof partsData[0]): string => {
        if (part.companyName === "ایساکو") {
            return PATHS.GENERAL.ISACO;
        }

        const companyId = findCompanyId(part.companyName);

        if (companyId) {
            return `${PATHS.GENERAL.PRODUCTS}?Page=1&SortOrder=2&Company=${companyId}`;
        }

        return `${PATHS.GENERAL.PRODUCTS}?Page=1&SortOrder=2`;
    };



    return (
        <Box
            display = "flex"
            alignItems = "center"
            position = "relative"
            py = {4}
            gap = {2}
            flexDirection = {{xs: "column", sm: "row"}}
        >
            {partsData.map((part, index) => (
                <Button
                    key = {index}
                    fullWidth
                    component = {Link}
                    href={getPartLink(part)}
                    size = "small"
                    variant = "contained"
                    onMouseEnter = {() => handleTouchStart(index)}
                    onTouchStart = {() => handleTouchStart(index)}
                    onMouseLeave = {handleTouchEnd}
                    onTouchEnd = {handleTouchEnd}
                    onTouchCancel = {handleTouchEnd}
                    sx = {{
                        fontSize: {xs: 12, sm: 14, md: 20},
                        py: 2,
                        height: {sm: 100, xs: 90},
                        display: "flex",
                        gap: 2,
                        borderWidth: 1,
                        borderStyle: "solid",
                        bgcolor: "background.paper",
                        borderColor: "primary.main",
                        color: "primary.dark",
                        transition: "all 0.3s ease",
                        "&:hover": {
                            color: "common.white",
                            bgcolor: "primary.light",
                            borderColor: "primary.light",
                            transform: "translateY(-3px)",
                            "& .MuiTypography-root": {
                                color: "common.white",
                            },
                            "& .hover-image": {
                                transform: "scale(1.1)",
                            },
                        },
                    }}
                    disableElevation
                >
                    <Box sx = {{transition: "transform 0.3s ease"}} className = "hover-image" >
                        <Image
                            src = {
                                hoveredIndex === index
                                    ? `/images/isaco/${part.baseName}.png`
                                    : `/images/isaco/${part.baseName}1.png`
                            }
                            alt = {part.title}
                            width = {60}
                            height = {60}
                        />
                    </Box >

                    <Box
                        display = "flex"
                        flexDirection = "column"
                        textAlign = "center"
                        sx = {{
                            transition: "all 0.3s ease",
                        }}
                    >
                        <Typography
                            color = "primary.main"
                            fontSize = {{xs: 14, sm: 14, md: 16}}
                            fontWeight = {500}
                            variant = "h6"
                        >
                            {part.title}
                        </Typography >

                        <Typography fontWeight = {300} color = "primary.light" >
                            به همراه قیمت‌ به‌روز و قابلیت جست‌وجو
                        </Typography >
                    </Box >
                </Button >
            ))}
        </Box >
    );
}
